import _ from 'lodash'
import { Result, ok, err } from '@xlearn/common'
import * as Api from '../api'
import { inject, injectable } from 'inversify'
import { stateSerializerNameMatch, StateSerializationPlugin, StateSerializerName } from '../api'

type PluginResolver = () => Api.StateSerializationPlugin<unknown>[]
export const StateSerializationPluginResolverSymbol = Symbol.for('StateSerializationPluginResolver')

@injectable()
export class DefaultStateSerializerFactory implements Api.StateSerializationFactory {

  private resolvedPlugins?: Api.StateSerializationPlugin<unknown>[] = undefined

  constructor(
    @inject(StateSerializationPluginResolverSymbol)
    private resolver: PluginResolver) {
  }

  resolveByName<T>(name: StateSerializerName, format: string): Result<Api.StateSerializationPlugin<T>, 'not-found'> {
    const found = this.plugins.find(x => stateSerializerNameMatch(name, x.key.name) && x.key.format === format)
    if (!found) {
      return err('not-found')
    }

    return ok(found as StateSerializationPlugin<T>)
  }

  resolveById<T>(id: number, format: string): Result<Api.StateSerializationPlugin<T>, 'not-found'> {

    const found = this.plugins.find(x => x.key.id === id && x.key.format === format)
    if (!found) {
      return err('not-found')
    }

    return ok(found as StateSerializationPlugin<T>)
  }

  private get plugins() {
    if (this.resolvedPlugins !== undefined) {
      return this.resolvedPlugins
    }

    const plugins = this.resolver()
    const duplicated = this.checkForDuplications(plugins)
    if (duplicated.length > 0) {
      throw new Error(`Coding error: state serializer duplications found: '${JSON.stringify(duplicated)}'`)
    }
    
    this.resolvedPlugins = plugins
    return plugins
  }

  private checkForDuplications(plugins: StateSerializationPlugin<unknown>[]) {
    const duplicated = plugins.filter((value, i, iteratee) =>
          iteratee.map(x => x.key.id).includes(value.key.id, i + 1))

    return duplicated
  }
}
